import '.hn{line-height:1.375rem;}.ssr-plugin'
import '.ck{font-size:0.875rem;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.b2{align-items:stretch;}.ssr-plugin'
import '.hm{gap:0.38rem;}.ssr-plugin'
import '.hd{padding:0.5rem 1rem;}.ssr-plugin'
import '.aa{align-items:center;}.ssr-plugin'
import '.n{gap:0.5rem;}.ssr-plugin'
import '.cd{flex-grow:1;}.ssr-plugin'
import '.c0{padding:0px;}.ssr-plugin'
import '.by{border:none;}.ssr-plugin'
import '.gn{outline:none;}.ssr-plugin'
import '.dr{background:transparent;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  KeyboardEvent,
  MutableRefObject,
  forwardRef,
  FocusEventHandler,
  KeyboardEventHandler,
} from 'react'
import { Text } from '../../typography/Text'

export type TextInputProps = {
  text: string
  placeholder?: string
  label?: string
  errorMessage?: string
  style?: Style
  ref?: MutableRefObject<HTMLInputElement>
  setText: (text: string) => void
  onBlur?: FocusEventHandler<HTMLInputElement>
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
}

export const BorderlessTextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      text,
      placeholder,
      label,
      errorMessage,
      style,
      setText,
      onBlur,
      onKeyDown,
    }: TextInputProps,
    ref,
  ) => {
    const errorStateOn = !!errorMessage
    const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
      if (onKeyDown) {
        onKeyDown(event)
      }
    }

    return (
      <styled.div className="hn ck l m b2 hm hd"
        style={{
          '&:has(:disabled)': {
            cursor: 'not-allowed',
          },
          ...style,
        }}
      >
        <div className="l aa n"
          style={{
            background: errorStateOn
              ? 'var(--palette-red-100)'
              : 'var(--palette-white)',
          }}
        >
          {label && <styled.div>{label}</styled.div>}
          <styled.input className="cd c0 by gn dr"
            placeholder={placeholder}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={onBlur}
            onKeyDown={handleKeyDown}
            ref={ref}
            style={{
              '&::placeholder': {
                color: errorStateOn
                  ? 'var(--palette-red-400)'
                  : 'var(--gray-300)',
                userSelect: 'none',
              },
              '&:disabled': {
                cursor: 'not-allowed',
              },
            }}
          ></styled.input>
        </div>
        {errorStateOn && (
          <Text.ExtraSmall style={{ color: 'var(--palette-red-600)' }}>
            {errorMessage}
          </Text.ExtraSmall>
        )}
      </styled.div>
    )
  },
)

BorderlessTextInput.displayName = 'BorderlessTextInput'
